<app-page
  pageTitle="Klijenti"
  pageDescription="Upravljanje pravnim i fizičkim licima"
>
  @if (stats(); as s) {
    <div class="mt-5 flex flex-column md:flex-row gap-4">
      <div class="stat-container flex align-items-center flex-1">
        <div class="stat-icon">
          <app-users-01 stroke="#414651"></app-users-01>
        </div>
        <div class="ml-4 flex flex-column">
          <div class="text-sm-semibold text-gray-600">Ukupno klijenata</div>
          <div class="mt-2 display-sm-semibold text-gray-900">{{ s.totalClients }}</div>
        </div>
      </div>
      <div class="stat-container flex align-items-center flex-1">
        <div class="stat-icon">
          <app-building-05 stroke="#414651"></app-building-05>
        </div>
        <div class="ml-4 flex flex-column">
          <div class="text-sm-semibold text-gray-600">Pravna lica</div>
          <div class="mt-2 display-sm-semibold text-gray-900">{{ s.companyClients }}</div>
        </div>
      </div>
      <div class="stat-container flex align-items-center flex-1">
        <div class="stat-icon">
          <app-user-circle stroke="#414651"></app-user-circle>
        </div>
        <div class="ml-4 flex flex-column">
          <div class="text-sm-semibold text-gray-600">Fizička lica</div>
          <div class="mt-2 display-sm-semibold text-gray-900">{{ s.individualClients }}</div>
        </div>
      </div>
    </div>
  }
  <app-admin-clients-table></app-admin-clients-table>
</app-page>
